const initialState = {
    obj: {}
}

const userReducer = (state = initialState, action) => {
    switch(action.type){
        case 'USER' : {
            return {
                ...state,
                obj: action.obj
            }
        }
        default: {
            return state
        }
    }
}

export default userReducer